import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, Input } from '@angular/core';
import { MatAccordionDisplayMode } from '@angular/material/expansion';
import { ADPResourceService } from 'digital-core';
import { IFaq, IFaqListItemKeys } from 'src/app/model/sitefinity/IFaq';

@Component({
  selector: 'pgh-spoe-dashboard-faq',
  templateUrl: './spoe-dashboard-faq.component.html',
  styleUrls: ['./spoe-dashboard-faq.component.scss'],
})
export class SPOEDashboardFaqComponent implements OnInit {
  @Input() displayMode: MatAccordionDisplayMode;
  @Input() faq: IFaq;
  @Input() faqListItems: IFaqListItemKeys[];
  @Input() faqImageKey: string;

  currentlyOpenedItemIndex = -1;
  faqImageUrl: string = '';
  faqImageAltText: string = '';

  constructor(
    private breakpointObserver: BreakpointObserver,
    private resourceService: ADPResourceService
  ) {}

  ngOnInit(): void {
    //this.setOpened(0);
    this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe((result) => {
      if (result.matches) {
        this.faqImageUrl = null;
        this.faqImageAltText = "";
      } else {
        this.faqImageUrl = this.resourceService.getPortalImage(this.faqImageKey).ImageURL;
        this.faqImageAltText = this.resourceService.getPortalImage(this.faqImageKey).Caption;
      }
    });
  }

  setOpened(itemIndex: number) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex: number) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
